import { FormattedMessage } from 'react-intl';

export type CodeReviewerSettingContainerTypeName = 'repository' | 'workspace';
export type CodeReviewerSettingContainerTypeATI =
  | 'ati:cloud:bitbucket:repository'
  | 'ati:cloud:bitbucket:workspace';
export type CodeReviewerSettingContainerTypeARI =
  | 'ari:cloud:bitbucket::repository'
  | 'ari:cloud:bitbucket::workspace';

export class CodeReviewerSettingContainerType {
  private constructor(
    public readonly name: CodeReviewerSettingContainerTypeName,
    public readonly ati: CodeReviewerSettingContainerTypeATI,
    public readonly ari: CodeReviewerSettingContainerTypeARI
  ) {}

  static readonly Repository: CodeReviewerSettingContainerType =
    new CodeReviewerSettingContainerType(
      'repository',
      'ati:cloud:bitbucket:repository',
      'ari:cloud:bitbucket::repository'
    );
  static readonly Workspace: CodeReviewerSettingContainerType =
    new CodeReviewerSettingContainerType(
      'workspace',
      'ati:cloud:bitbucket:workspace',
      'ari:cloud:bitbucket::workspace'
    );
}

export enum RepositoryAutomaticTrigger {
  CREATED_ONLY = 'CREATED_ONLY',
  CREATED_AND_UPDATED = 'CREATED_AND_UPDATED',
  NEVER = 'NEVER',
}

export type RepositorySettings = {
  isEnabled: boolean;
  isAcceptanceCriteriaEnabled: boolean;
  isAcceptanceCriteriaCommitTriggerEnabled: boolean;
  automaticTrigger: RepositoryAutomaticTrigger | null;
};

export type CodeReviewerRepositorySetting = {
  error: FormattedMessage.MessageDescriptor | null;
  isLoading: boolean;
  workspaceSettings: WorkspaceSettings;
  isRepositoryDisabledForAutoreview: boolean;
  repositorySettings: RepositorySettings;
  updateRepositorySetting: <K extends keyof RepositorySettings>(
    setting: K,
    value: RepositorySettings[K]
  ) => void;
};

export type CodeReviewerWorkspaceSetting = {
  error: FormattedMessage.MessageDescriptor | null;
  isLoading: boolean;
  workspaceSettings: WorkspaceSettings;
  updateWorkspaceSetting: <K extends keyof WorkspaceSettings>(
    setting: K,
    value: WorkspaceSettings[K]
  ) => void;
};

export type CodeReviewerSetting = CodeReviewerRepositorySetting &
  CodeReviewerWorkspaceSetting;

export type WorkspaceSettings = {
  isEnabledAtWorkspace: boolean;
  cloudIdAssociation: string | null;
};
